// Shared sx primitives for the Course module's B13 restyle. Extracted
// because List, Detail, Create, Edit and CourseFormBody all render the
// same hairline-bordered surface and the same B13-primary button pair.
// Kept in the module (not theme/) because these override the theme-level
// primary — full-app primary swap is a separate conversation.
import { SxProps, Theme } from "@mui/material";
import { B13, B13Ink, tint12 } from "../../../theme/b13Tokens";

export const surfaceSx: SxProps<Theme> = {
  p: 2,
  borderRadius: 2,
  border: `1px solid ${B13.line}`,
  bgcolor: B13.surface,
};

export const primaryBtnSx: SxProps<Theme> = {
  textTransform: "none",
  fontWeight: 600,
  borderRadius: 2,
  bgcolor: B13.primary,
  color: B13.surface,
  boxShadow: "none",
  "&:hover": { bgcolor: B13.primary, filter: "brightness(0.95)", boxShadow: "none" },
  "&.Mui-disabled": { bgcolor: tint12(B13.primary), color: B13Ink.ink3, boxShadow: "none" },
};

export const secondaryBtnSx: SxProps<Theme> = {
  textTransform: "none",
  fontWeight: 600,
  borderRadius: 2,
  color: B13.ink,
  borderColor: B13.line,
  bgcolor: B13.surface,
  "&:hover": { bgcolor: tint12(B13.primary), borderColor: B13.primary, color: B13.primary },
  "&.Mui-disabled": { color: B13Ink.ink3, borderColor: B13.line, bgcolor: B13.surface },
};
